import { findPageDescriptorById } from './util.find-page-descriptor-by-id.js';

function findRootPageDescriptor(state, pageDescriptor) {
  let rootPageDescriptor = pageDescriptor;
  while (rootPageDescriptor == null ? void 0 : rootPageDescriptor.parentId) {
    rootPageDescriptor = findPageDescriptorById(
      state,
      rootPageDescriptor.parentId
    );
  }
  if (!rootPageDescriptor) {
    throw new Error(
      "getRootPageDescriptor(): An error occurred, root descriptor not found"
    );
  }
  return rootPageDescriptor;
}

export { findRootPageDescriptor };
//# sourceMappingURL=descriptor.get-root.js.map
